import { WORKOUT_PHASE_TYPES } from "../../../../containers/FitnessPlan/constants";
import { fonts } from "../../../../styles/fonts";
import { colors } from "../../../../styles/colors";

const verticalLineColorKey = {
    [WORKOUT_PHASE_TYPES.WARMUP]: '#ffe38e',
    [WORKOUT_PHASE_TYPES.WORKOUT]: '#8cdff8',
    [WORKOUT_PHASE_TYPES.COOLDOWN]: '#b5baff'
};

const workoutOuterWrapper = {
    padding: 20,
    borderRadius: 10,
    border: "1px solid rgb(175, 198, 219)",
    marginBottom: 30
}

const workoutPhaseHeadersWrapper = {
    display: "flex",
    gap: "3%"
}

const workoutPhaseHeader = {

}

const workoutPhaseLabel = {
    fontFamily: fonts.boldFont,
    fontSize: 24,
    width: 110,
    // marginRight: 60,
    alignSelf: "center"
}

const verticalBar = (props: any) => ({
    background: verticalLineColorKey[props.blockType],
    borderRadius: 3,
    width: 6
})

const workoutPhaseLabelWrapper = {
    display: "flex",
    gap: 15,
    marginRight: 20
}

const movementLabel: any = {
    color: colors.darkerGrey,
    fontFamily: fonts.boldFont,
    fontSize: 16,
    textDecoration: "underline",
    marginLeft: 35
}

const movementWrapper = {
    marginTop: 31
}

const movementHeader = {
    display: "flex"
}

export {
    workoutOuterWrapper,
    workoutPhaseHeadersWrapper,
    workoutPhaseHeader,
    workoutPhaseLabel,
    workoutPhaseLabelWrapper,
    verticalBar,
    movementLabel,
    movementWrapper,
    movementHeader
}